import { render, staticRenderFns } from "./lawDetail.vue?vue&type=template&id=22138685&scoped=true"
import script from "./lawDetail.vue?vue&type=script&lang=js"
export * from "./lawDetail.vue?vue&type=script&lang=js"
import style0 from "./lawDetail.vue?vue&type=style&index=0&id=22138685&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22138685",
  null
  
)

export default component.exports